import { createSlice } from "@reduxjs/toolkit";

import { IRedoReasonResponse } from "../../typings/interfaces/responses";
import {
    createRedoReasonAction,
    deleteRedoReasonAction,
    getAllRedoReasonsAction,
    updateRedoReasonAction,
} from "../actions/redoReasonsAction";

export interface RedoReasonState {
    redoReasons: IRedoReasonResponse[] | null;
    redoReasonsLoading: boolean;
    redoReasonsError: string | null;

    addRedoReasonResponse: IRedoReasonResponse | null;
    addRedoReasonLoading: boolean;
    addRedoReasonError: string | null;

    deleteRedoReasonResponse: boolean | null;
    deleteRedoReasonLoading: boolean;
    deleteRedoReasonError: string | null;

    updateRedoReasonResponse: IRedoReasonResponse | null;
    updateRedoReasonLoading: boolean;
    updateRedoReasonError: string | null;
}

const initialState: RedoReasonState = {
    redoReasons: null,
    redoReasonsLoading: false,
    redoReasonsError: null,

    addRedoReasonResponse: null,
    addRedoReasonLoading: false,
    addRedoReasonError: null,

    deleteRedoReasonResponse: null,
    deleteRedoReasonLoading: false,
    deleteRedoReasonError: null,

    updateRedoReasonResponse: null,
    updateRedoReasonLoading: false,
    updateRedoReasonError: null,
};

const redoReasonsSlice = createSlice({
    name: "redoReasons",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get All
        builder
            .addCase(getAllRedoReasonsAction.pending, (state) => {
                state.redoReasons = null;
                state.redoReasonsLoading = true;
                state.redoReasonsError = null;
            })
            .addCase(getAllRedoReasonsAction.fulfilled, (state, action) => {
                state.redoReasonsError = null;
                state.redoReasonsLoading = false;
                state.redoReasons = (action.payload as any).body;
            })
            .addCase(getAllRedoReasonsAction.rejected, (state, action) => {
                state.redoReasons = null;
                state.redoReasonsLoading = false;
                state.redoReasonsError = (action.payload as any).message;
            });

        // Create
        builder
            .addCase(createRedoReasonAction.pending, (state) => {
                state.addRedoReasonResponse = null;
                state.addRedoReasonLoading = true;
                state.addRedoReasonError = null;
            })
            .addCase(createRedoReasonAction.fulfilled, (state, action) => {
                state.addRedoReasonResponse = (action.payload as any).body;
                state.addRedoReasonLoading = false;
                state.addRedoReasonError = null;
            })
            .addCase(createRedoReasonAction.rejected, (state, action) => {
                state.addRedoReasonResponse = null;
                state.addRedoReasonLoading = false;
                state.addRedoReasonError = (action.payload as any).message;
            });

        // Delete
        builder
            .addCase(deleteRedoReasonAction.pending, (state) => {
                state.deleteRedoReasonResponse = null;
                state.deleteRedoReasonLoading = true;
                state.deleteRedoReasonError = null;
            })
            .addCase(deleteRedoReasonAction.fulfilled, (state, action) => {
                state.deleteRedoReasonResponse = action.payload;
                state.deleteRedoReasonLoading = false;
                state.deleteRedoReasonError = null;
            })
            .addCase(deleteRedoReasonAction.rejected, (state, action) => {
                state.deleteRedoReasonResponse = null;
                state.deleteRedoReasonLoading = false;
                state.deleteRedoReasonError = (action.payload as any).message;
            });

        // Update
        builder
            .addCase(updateRedoReasonAction.pending, (state) => {
                state.updateRedoReasonResponse = null;
                state.updateRedoReasonLoading = true;
                state.updateRedoReasonError = null;
            })
            .addCase(updateRedoReasonAction.fulfilled, (state, action) => {
                state.updateRedoReasonResponse = action.payload;
                state.updateRedoReasonLoading = false;
                state.updateRedoReasonError = null;
            })
            .addCase(updateRedoReasonAction.rejected, (state, action) => {
                state.updateRedoReasonResponse = null;
                state.updateRedoReasonLoading = false;
                state.updateRedoReasonError = (action.payload as any).message;
            });
    },
});

export default redoReasonsSlice.reducer;
export const redoReasonsSliceActions = redoReasonsSlice.actions;
